import { createAction } from 'redux-actions';

export const SET_COMPLAINTS_APN = 'COMPLAINTS.SET_COMPLAINTS_APN';
export const setComplaintsAPN = createAction(SET_COMPLAINTS_APN);
